(function($) {

	'use strict';

	var init = function() {
        toggleNav();
		toggleSubNav();
		toggleAgenda();
		closeMonth();
		
		$(window).resize(function(){

			if($(window).width() < 768){

				$(".mainHeader__mainNav__list").mCustomScrollbar({
					theme:"minimal",
					scrollInertia:500,
				});

			}else{
				$(".mainHeader__mainNav__list").mCustomScrollbar("destroy");
			}

		}).resize();

	};

	var toggleNav = function(){

		$('#toggleNav').click(function(){

			$(this).toggleClass('active');
			$('.mainHeader').toggleClass('active');

		});

	};

	var toggleSubNav = function(){

		$('.menu-item-has-children > a').click(function(e){

			if($(window).width() < 768){

				e.preventDefault();

				if($(this).parent('.menu-item-has-children').hasClass('active')){
					$(this).parent('.menu-item-has-children').removeClass('active')
				}else{
					$('.menu-item-has-children').removeClass('active');
					$(this).parent('.menu-item-has-children').addClass('active')
				}

			}

		});

	};

	var toggleAgenda = function(){

		$('.agendaTrigger').click(function(){

			$('#agenda').toggleClass('active');

		});

	};

	var closeMonth = function(){

		$('.agendaMonth__title').click(function(){

			$(this).parent('.agendaMonth').toggleClass('close');

		});

	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
